import * as React from "react";
import s from "./common.scss";
import cln from "classnames";

export function Header({
	children,
	className,
	size = "nano",
	align = "start",
	...rest
}: React.HTMLAttributes<HTMLDivElement> & {
	size?: "quarck" | "nano" | "xs" | "sm";
	align?: "start" | "center" | "end";
}) {
	return (
		<header className={cln(s.header, s[size], s[align], className)} {...rest}>
			{children}
		</header>
	);
}

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement>;

export function Title({ children, className, ...rest }: HeadingProps) {
	return (
		<h2 className={cln(s.title, className)} {...rest}>
			{children}
		</h2>
	);
}

type TypographyProps = React.HTMLAttributes<HTMLParagraphElement>;

export function Description({ children, className, ...rest }: TypographyProps) {
	return (
		<p className={cln(s.description, className)} {...rest}>
			{children}
		</p>
	);
}
